require('./home.less');

var ajax = require('@enhancer/fe-util-ajax');
var locale = require('../../i18n');
var util = require('../../app/util');
var app = require('../../app/app');
var homeTpl = require('./home.html');

var pageConfig = window.pageConfig;
var path = pageConfig.path;

window.enhancer = window.enhancer || {};





function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var binary = atob(arr[1]);
  var array = [];
  for(var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
  }
  return new Blob([new Uint8Array(array)], {type: mime});
}


function onCredential(res, src, cb) {
  var params = res.credential.params;
  var formData = new FormData();
  var file = dataURLtoFile(src, 'avatar.png');

  formData.append('key', params.key);
  formData.append('policy', params.policy);
  formData.append('OSSAccessKeyId', params.OSSAccessKeyId);
  formData.append('success_action_status', params.success_action_status);
  formData.append('signature', params.signature);
  formData.append('file', file);

  var xhr = new window.XMLHttpRequest();
  xhr.open('POST', res.credential.host);
  xhr.send(formData); //发送表单数据  
  xhr.onreadystatechange = () => { //在这里指定上传成功的回调函数，接受返回值  
    if (xhr.readyState == 4) {
      if (xhr.status == 200) {
        cb(res.credential.host + '/' + params.key);
      } else {
        console.log(xhr);
      }
    }
  }

  /*
  ajax({
      url: res.credential.host,
      type: 'POST',
      data: formData,
      headers: {"Access-Control-Allow-Origin": location.host}
      ,processData: false
      //,contentType: false
      //,crossDomain: true
  }, function () {
      onFileLink(res.credential.host + '/' + params.key)
  });
  */
}
enhancer.setAvatar = function(src) {
  $('.user-avatar img').prop('src', src);
  $('.image-crop .close').click();
  $('input[name=avatar]').val(src);
}


function init() {
  $('.btn-edit').click(function(e) {
    e.preventDefault();

    $('.user-info').addClass('edit-mode');
  });

  var accountCache = {};
  var loading = false;
  function checkNickNameExist (nickname, cb) {
    if (accountCache[nickname]) {
      cb(null, accountCache[nickname]);
    } else {
      if (loading) {
        return
      }
      loading = true;
      ajax({
        type: 'GET',
        url:  '/api/nickname?nickname=' + encodeURIComponent(nickname)
      }, function (res) {
        loading = false;
        if (res.success) {
          if (res.exist) {
            accountCache[nickname] = 2;
          } else {
            accountCache[nickname] = 1;
          }
          cb(null, accountCache[nickname]);
        } else {
          util.show(res.message);
          console.log(res);
        }
      }, function (err) {
        loading = false;
        cb(err);
      });
    }
  }

  var validate = window.pageConfig.validate;

  $('#nickname').on('blur', function () {
    var val = $(this).val().trim();
    var focusValue = $(this).data('focusValue');
    var oldValue = $(this).data('focusValue');
    var ele = $(this);

    if (val === oldValue) {
      return;
    }

    if (val.length > validate.nicknameMaxLength) {
      ele.next('label').text(locale('nicknameLong', {
        max: validate.nicknameMaxLength
      }));
      ele.addClass('error');
      return
    }
    if (val.length < validate.nicknameMinLength) {
      ele.next('label').text(locale('nicknameShort', {
        min: validate.nicknameMinLength
      }));
      ele.addClass('error');
      return
    }
    if (accountCache[val] == 2) {
      ele.next('label').text(locale('nicknameExists'));
      ele.addClass('error');
      return
    }
    if (val && val !== focusValue) {
      checkNickNameExist(val, function (err, type) {
        if (type === 2) {
          ele.next('label').text(locale('nicknameExists'));
          ele.addClass('error');
        } else {
          ele.removeClass('error');
        }
      })
    }
  }).on('focus', function () {
    $(this).data('focusValue', $(this).val().trim());
    $(this).removeClass('error');
  });



  $('.btn-save').click(function(e) {
    e.preventDefault();

    if ($('.edit-data.error').length) {
      return
    }

    var info = $('.user-info.edit-mode');
    var save = {};
    var toSave = false;
    info.find('input[type=text]').each(function() {
      var val = $(this).val().trim();
      var old = $(this).attr('oldValue');
      if (old != val && val) {
        toSave = true;
        save[$(this).prop('name')] = val;
      }
    });

    if (!toSave) {
      $('.btn-cancel').click();
      return
    }

    function submit () {
      ajax({
        type: 'POST',
        data: save,
        url: '/api/userinfo'
      }, function(res) {
        if (res.success) {
          for (var i in save) {
            var ele = $('[name=' + i + ']');
            ele.attr('oldValue', save[i]);
            ele.prev('span').text(save[i]);
          }
          info.removeClass('edit-mode');
          if (save.nickname) {
            $('.header .user-info .nick-name').text(save.nickname);
          }
          if (save.avatar) {
            $('.header .user-info .avatar-on-head').attr('src', save.avatar);
          }

          if (res.data.point) {
            $('.user-point').text(parseInt($('.user-point').text(), 10) + res.data.point);
          }
        } else {
          util.show(res.message);
        }
      });
    }


    var checkMap = {
      nickname: function (cb) {
        if (save.nickname.length > validate.nicknameMaxLength) {
          return true;
        }
        if (save.nickname.length < validate.nicknameMinLength) {
          return true;
        }
        if (accountCache[save.nickname] == 2) {
          // $('.btn-cancel').click();
          return true
        }

        if (accountCache[save.nickname]) {
          cb();
          return
        }
        setTimeout(function () {
          cb();
        }, 1000);
      },
      avatar: function (cb) {
        if (save.avatar.indexOf('//') === 0) {
          return cb();
        }
        ajax({
          url: '/api/osscredential'
        }, function(res) {
          if (!res.success) {
            return util.show(res.message);
          }
          onCredential(res, save.avatar, function (url) {
            save.avatar = url;
            $('input[name=avatar]').val(url);
            cb();
          });
        });
      }
    }

    var count = 0;
    var keys = Object.keys(save);
    function addCount() {
      count++;
      if (count === keys.length) {
        submit();
      }
    }

    keys.some(function (key) {
      if (checkMap[key]) {
        return checkMap[key](addCount);
      } else {
        addCount();
      }
    });
  });

  $('.btn-cancel').click(function(e) {
    e.preventDefault();
    $('.user-info').removeClass('edit-mode').find('input[type=text]').each(function() {
      $(this).val($(this).attr('oldValue'));
    });
    $('.edit-data.error').removeClass('error');
  });

  $('.user-avatar img').click(function() {
    if ($('.form-wrap.user-info').hasClass('edit-mode')) {
      $('.user-avatar input[type=file]').click();
    }
  });
  $('.user-avatar input[type=file]').on('change', function(e) {
    var files = e.target.files;
    [].forEach.call(files, function(item) {
      if (item.type.match('image.*')) {
        var src = URL.createObjectURL(item);
        showCrop(src);
      }
    });
    this.value = '';
  });

  function showCrop(src) {
    var iframe = $('.image-crop iframe');

    if (iframe.length) {
      var child = iframe[0].contentWindow;
      if (iframe.data('loaded') && child.enhancer && child.enhancer.setImage) {
        child.enhancer.setImage(src);
        $('.image-crop, .mask').show();
      } else {
        setTimeout(function() {
          showCrop(src);
        }, 1000);
      }
    } else {
      iframe = document.createElement('iframe');
      iframe.src = "/crop";
      $(iframe).on('load', function() {
        $(iframe).data('loaded', true);
        showCrop(src);
      });
      $('.image-crop').append(iframe);
    }
  }

  $('.image-crop .close').click(function() {
    $('.image-crop, .mask').hide();
  });
}


$(document).ready(function() {
  ajax({
    url: '/api/userinfo'
  }, function(res) {
    if (res.success) {
      var data = {
        locale: locale(),
        domain0: location.hostname.match(/\w+\.\w+$/)
      };
      data.user = res.user;
      data.user.create = util.format(data.user.created);
      data.user.last = util.format(data.user.last);
      data.user.avatar = res.user.avatar;
      data.user.point = (data.user.point || 0) + '';
      data.user.experience = (data.user.experience || 0) + '';
      data.points = res.points || [];
      data.points.forEach(function(item) {
        item.link = item.url;
      })

      var html = homeTpl(data);
      $('body').append(html);
      init();
    } else {
      util.show(res.message, 'error');
    }
  });

  $('.header a.user-info').addClass('selected');
});


// WEBPACK FOOTER //
// ./src/pages/home/home.js